<template>
  <v-layout wrap>
    <v-menu
      v-model="showPicker"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="200px"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          hide-details
          :variant="variant ?? 'underlined'"
          :rules="rules"
          :label="pickerTitle"
          :prepend-icon="prependIcon"
          readonly
          :model-value="displayValue"
          v-bind="props"
          :clearable="clearable"
          @click:clear="clearValue"
          color="light-green darken-1"
          :hint="hint"
          :persistent-hint="persistentHint"
        ></v-text-field>
      </template>
      <v-date-picker
        locale="cs-CZ"
        :min="minDate"
        :max="maxDate"
        :first-day-of-week="1"
        v-model="dateValue"
        :show-current="false"
        no-title
        @update:model-value="sendValue"
        :allowed-dates="allowedDates"
        :style="$vuetify.display.mdAndDown ? 'transform: scale(0.75)' : ''"
      ></v-date-picker>
    </v-menu>
  </v-layout>
</template>

<script setup>
import {computed, ref, watch} from "vue";
import moment from "moment/moment";

const props = defineProps({
  rules: Array,
  initialValue: String,
  title: String,
  minDate: String,
  maxDate: String,
  clearable: Boolean,
  customPrependIcon: String,
  hint: String,
  persistentHint: Boolean,
  allowedDates: Function,
  variant: String,
})

const emit = defineEmits(['dateChanged'])

const showPicker = ref(false)
const dateValue = ref(props.initialValue ? new Date(props.initialValue) : undefined)
const pickerTitle = ref(props.title ? props.title : 'Datum')
const prependIcon = ref(props.customPrependIcon ? props.customPrependIcon : 'event')

const displayValue = computed(() => {
  return dateValue.value ? moment(dateValue.value).format('L') : undefined;
})

function sendValue() {
  showPicker.value = false;
  emit('dateChanged', moment(dateValue.value).startOf('day'));
}

function clearValue() {
  dateValue.value = undefined;
  emit('dateChanged', undefined);
}

watch(() => props.minDate, (value)=>{
  if (moment(value) > moment(dateValue.value)) {
    dateValue.value = undefined;
  }
})
</script>